import React, { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Arrow } from "./Icons";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/services", label: "Services" },
  { to: "/solutions", label: "Upcoming Solutions" },
  { to: "/about", label: "About" },
  { to: "/insights", label: "Insights" },
  { to: "/contact", label: "Contact" },
];

export function Logo() {
  return (
    <Link to="/" className="logo" aria-label="Victrie home">
      <svg className="logo__mark" viewBox="0 0 64 64" aria-hidden="true">
        <defs>
          <linearGradient id="lg" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#ff6b3d" />
            <stop offset="1" stopColor="#ffb547" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="14" fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.15)" />
        <path d="M14 16 L32 50 L50 16" fill="none" stroke="url(#lg)" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="32" cy="50" r="4" fill="#ffb547" />
      </svg>
      <span>Victrie</span>
    </Link>
  );
}

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  return (
    <>
      <header className={`nav ${scrolled || open ? "scrolled" : ""}`}>
        <div className="container nav__inner">
          <Logo />
          <nav aria-label="Primary">
            <ul className="nav__links">
              {links.map((l) => (
                <li key={l.to}>
                  <NavLink to={l.to} end={l.end}>{l.label}</NavLink>
                </li>
              ))}
            </ul>
          </nav>
          <div className="nav__cta">
            <Link to="/contact" className="btn btn--primary">Start a project <Arrow /></Link>
            <button className={`nav__burger ${open ? "open" : ""}`} aria-label="Toggle menu" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
              <span /><span /><span />
            </button>
          </div>
        </div>
      </header>
      <div className={`nav__mobile ${open ? "open" : ""}`} aria-hidden={!open}>
        {links.map((l) => (
          <NavLink key={l.to} to={l.to} end={l.end}>{l.label}</NavLink>
        ))}
        <Link to="/contact" className="btn btn--primary btn--lg" style={{ marginTop: 16, justifyContent: "center" }}>Start a project <Arrow /></Link>
      </div>
    </>
  );
}
